class ME_Conference_Descriptions {
 constructor() {
  this.descShow();
 }
 descShow() {
  let popupConfContainer = document.querySelectorAll('.conference-program');
  if (!popupConfContainer.length) {
   return
  }
  for (let i = 0; i < popupConfContainer.length; i++) {
   let popupConfButtons = popupConfContainer[i].querySelectorAll('a[data-id]');
   let href;
   let item;
   let heigthShow;

   function openDescription(container) {
    item = document.querySelector(`${container}-${href}`);
    if (item.classList.contains('show')) {
     setTimeout(() => {
      item.classList.remove('show');
     }, 500);
     item.style.height = `${heigthShow}px`;
     setTimeout(() => {
      item.style.height = `0px`;
     }, 50);
    } else {
     setTimeout(() => {
      heigthShow = item.scrollHeight;
      item.classList.add('show');
      item.style.height = `${heigthShow}px`;
      setTimeout(() => {
       item.style.height = `auto`;
      }, 201);
     }, 200);
    }
   }

   popupConfButtons.forEach(element => {
    element.addEventListener('click', function (e) {
     e.preventDefault();
     href = element.getAttribute('data-id');
     element.classList.toggle('open');
     if (element.classList.contains('open-abstract')) {
      openDescription('.abstract')
     }
     if (element.classList.contains('open-bionote')) {
      openDescription('.bionote')
     }
    })
   })
  }
 }
}
